module.exports = __webpack_public_path__ + "static/media/boysHandshake.6b079da8.jpeg";